import { defineStore } from "pinia";
import Services from '@/services/selfEmploymentServices'
import { mapSelfEmployment } from '@/helpers/mapFuncs'

export const useSelfEmploymentStore = defineStore("selfEmployment", {

state:()=>({
    selfEmployment: {},
    selfEmployments: [],
}),
getters : {
    getSelfEmployment() {
        return mapSelfEmployment(this.selfEmployment)
    },
    getSelfEmployments() {
        return this.selfEmployments.map(mapSelfEmployment)
    }
},
actions : {
    /** Start Sets */
    setSelfEmployment(selfEmployment) {
        this.selfEmployment = selfEmployment
    },
    setSelfEmployments(selfEmployments) {
        this.selfEmployments = selfEmployments
    },
    /** End Sets */

    /** Start Actions */
    get(id) {
        return Services.get(id)
        .then((response)=>{
            this.setSelfEmployment(response.data)
            return response
        })
    },
    getByPersonId(personId) {
        return Services.getByPersonId(personId)
        .then((response)=>{
            this.setSelfEmployments(response.data.data)
            return response
        })
    },
    getAll(data) {
        return Services.getAll(data)
        .then((response)=>{
            this.setSelfEmployments(response.data)
            return response
        })
    },
    add(data){
        return Services.add(data)
        .then((response)=>{
            this.selfEmployments.push(response.data.data)
            return mapSelfEmployment(response.data.data)
        })
    },
    edit(id, data){
        return Services.edit(id, data)
        .then((response)=>{
            this.selfEmployments[this.selfEmployments.findIndex((x)=>x.id == id)] = response.data.data
            return mapSelfEmployment(response.data.data)
        })
    },
    delete(id){
        return Services.delete(id)
        .then((response)=>{
            this.selfEmployments = this.selfEmployments.filter((x)=>x.id != id)
            return mapSelfEmployment(response.data.data)
        })
    },
    /** End Actions */
}
});